import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { permissionConstant, roleConstant } from '../app.constant';
import { User } from '../app.model';
import { AuthenticationService } from '../services/authentication.service';
import { DataSharedService } from '../services/data-shared.service';
import { environment } from 'src/environments/environment';
import { ContactSupportModalComponent } from '../components/contact-support-modal/contact-support-modal.component';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  @Input() isSideBarOpen: boolean | undefined;

  user: User;
  visible: Boolean = false;
  showDropUp: Boolean = false;
  mobilesettingshowDropDown: Boolean = false;
  permissionsMenu: any = [];
  showReportSubmenu: Boolean = false;
  navGroups: string[] = ['Main', 'Manage', 'Money', 'System'];

  constructor(
    public authService: AuthenticationService,
    public dataSharedService: DataSharedService,
    private modalService: NgbModal,
  ) {
    this.user = this.authService.userValue;
  }

  openHelpSupport(): void {
    this.modalService.open(ContactSupportModalComponent, {
      size: 'md',
      backdrop: true,
      windowClass: 'support-modal-window',
    });
  }

  async ngOnInit(): Promise<void> {
    this.permissionsMenu.push({
      path: '/dashboard',
      name: 'Dashboard',
      icon: 'bi bi-grid',
      group: 'Main',
    });
    const d: any = await localStorage.getItem('permissions');
    this.dataSharedService.permissionData = JSON.parse(d);

    this.dataSharedService.permissionData.forEach((element: any) => {
      switch (element.permission) {
        case permissionConstant.AGENCIES:
          this.permissionsMenu.push({
            path: '/agencies',
            name: element.permission,
            icon: 'bi bi-building',
            group: 'Manage',
          });
          break;
        case permissionConstant.CANDIDATES:
          if (this.user.role_uuid === roleConstant.AGENCY) {
            this.permissionsMenu.push({
              path: '/candidates',
              name: element.permission,
              icon: 'bi bi-people',
              group: 'Manage',
            });
          }
          break;
        case permissionConstant.JOBS:
          this.permissionsMenu.push({
            path: '/jobs',
            name: element.permission,
            icon: 'bi bi-briefcase',
            group: 'Manage',
          });
          break;
        case permissionConstant.TIMESHEETS:
          this.permissionsMenu.push({
            path: '/timesheets',
            name: element.permission,
            icon: 'bi bi-clock-history',
            group: 'Main',
          });
          break;
        case permissionConstant.CLIENTS:
          this.permissionsMenu.push({
            path: '/clients',
            name: element.permission,
            icon: 'bi bi-building',
            group: 'Manage',
          });
          break;
        case permissionConstant.ASSIGNMENTS:
          this.permissionsMenu.push({
            path: '/assignments',
            name: element.permission,
            icon: 'bi bi-layout-text-window-reverse',
            group: 'Manage',
          });
          break;
        /*case permissionConstant.ASSIGNMENTS:
          this.permissionsMenu.push({
            path: '/assignments',
            name: element.permission,
            icon: 'bi bi-briefcase',
          });
          break;*/

        case permissionConstant.REPORTS:
          this.permissionsMenu.push({
            path: '/reports/payroll',
            name: element.permission,
            icon: 'bi bi-pie-chart',
            group: 'Money',
          });
          break;
      }
    });

    if (this.user.role_uuid === roleConstant.AGENCY) {
      this.permissionsMenu.push({
        path: '/reports/payroll',
        name: 'Reports',
        icon: 'bi bi-pie-chart',
        group: 'Money',
      });

      this.permissionsMenu.push({
        path: '/invoices',
        name: 'Invoices',
        icon: 'bi bi-cash-stack',
        group: 'Money',
      });

      this.permissionsMenu.push({
        path: '/email-templates',
        name: 'Email Templates',
        icon: 'bi bi-envelope-paper',
        group: 'System',
      });
      this.permissionsMenu.push({
        path: '/email-logs',
        name: 'Email Logs',
        icon: 'bi bi-envelope-check',
        group: 'System',
      });
      this.permissionsMenu.push({
        path: '/activity-logs',
        name: 'Activity Logs',
        icon: 'bi bi-clock',
        group: 'System',
      });
      this.permissionsMenu.push({
        path: '/admins',
        name: 'Admins',
        icon: 'bi bi-people',
        group: 'System',
      });

      // GP Estimator menu entry. Temporary hardcoded agency-UUID gate until the
      // /api/agency/feature-flags endpoint ships (backend task #9). Backend
      // middleware (`gp-estimator-enabled`) is still the source of truth —
      // non-enabled agencies get a 403 even if the UUID check is bypassed.
      const GP_ESTIMATOR_AGENCY_UUID = '779921e6-ca76-48ed-9cd3-3289f16337f6';
      if (this.user.agency_uuid === GP_ESTIMATOR_AGENCY_UUID) {
        this.permissionsMenu.push({
          path: '/gp-estimator',
          name: 'GP Estimator',
          icon: 'bi bi-calculator',
          group: 'Money',
        });
      }
    }

    // if(this.user.role_uuid === roleConstant.CANDIDATE || this.user.role_uuid === roleConstant.CLIENT){
    //   this.permissionsMenu.push({
    //     path: '/tasks-list',
    //     name: 'Tasks',
    //     icon: 'bi bi-list-task',
    //   });
    // }

    const haveSettingsPermission = this.dataSharedService.permissionData.find((x: any) => x.permission === permissionConstant.SETTINGS);
    if (haveSettingsPermission) {
      this.permissionsMenu.push({
        path: '/settings',
        name: haveSettingsPermission.permission,
        icon: 'bi bi-gear-fill',
        group: 'System',
      });
    }
  }

  getMenusByGroup(group: string): any[] {
    return this.permissionsMenu.filter((m: any) => m.group === group);
  }

  toggleCollapse(): void {
    this.visible = !this.visible;
  }

  showDropdown() {
    this.showDropUp = !this.showDropUp;
  }

  showSubMenuDropdown(subMenu: any) {
    if (subMenu == 'reportSubMenu') {
      this.showReportSubmenu = !this.showReportSubmenu;
    }
  }
}